import { render } from "./WorkloadHealthScale.vue?vue&type=template&id=1daa0925&scoped=true"
import script from "./WorkloadHealthScale.vue?vue&type=script&lang=js"
export * from "./WorkloadHealthScale.vue?vue&type=script&lang=js"

import "./WorkloadHealthScale.vue?vue&type=style&index=0&id=1daa0925&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1daa0925"]])

export default __exports__